import React, { useState } from 'react';
import { useAudio } from '../../context/AudioContext';
import './AudioPlayer.css';

const AudioPlayer = () => {
    const {
        currentTrack,
        isPlaying,
        volume,
        currentTime,
        duration,
        isLoading,
        togglePlayPause,
        playNext,
        playPrevious,
        seek,
        changeVolume,
        playlist,
        currentTrackIndex,
        playTrack
    } = useAudio();

    const [showPlaylist, setShowPlaylist] = useState(false);
    const [showVolume, setShowVolume] = useState(false);

    const formatTime = (time) => {
        if (isNaN(time)) return '0:00';
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        const paddedSeconds = seconds < 10 ? '0' + seconds : seconds;
        return minutes + ':' + paddedSeconds;
    };

    const handleSeek = (e) => {
        const progressBar = e.currentTarget;
        const clickPosition = e.nativeEvent.offsetX;
        const width = progressBar.offsetWidth;
        const newTime = (clickPosition / width) * duration;
        seek(newTime);
    };

    const handleVolumeChange = (e) => {
        changeVolume(parseFloat(e.target.value));
    };

    const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

    return (
        <div className="audio-player-wrapper">
            <div className="audio-player">
                <div className="audio-player-container">
                    <div className="audio-player-album">
                        <img src={currentTrack.thumbnail} alt={currentTrack.title} />
                        {isLoading && <div className="loading-spinner"></div>}
                    </div>

                    <div className="audio-player-info">
                        <div className="track-title">{currentTrack.title}</div>
                        <div className="track-artist">{currentTrack.artist}</div>
                    </div>

                    <div className="audio-player-controls">
                        <button 
                            className="control-btn"
                            onClick={playPrevious}
                            disabled={currentTrackIndex === 0}
                        >
                            <i className="fa fa-step-backward"></i>
                        </button>
                        
                        <button 
                            className="control-btn control-btn-play"
                            onClick={togglePlayPause}
                            disabled={isLoading}
                        >
                            <i className={'fa ' + (isPlaying ? 'fa-pause' : 'fa-play')}></i>
                        </button>
                        
                        <button 
                            className="control-btn"
                            onClick={playNext}
                            disabled={currentTrackIndex === playlist.length - 1}
                        >
                            <i className="fa fa-step-forward"></i>
                        </button>
                    </div>

                    <div className="audio-player-progress">
                        <span className="time-current">{formatTime(currentTime)}</span>
                        <div className="progress-bar" onClick={handleSeek}>
                            <div 
                                className="progress-bar-fill" 
                                style={{ width: progress + '%' }}
                            ></div>
                        </div>
                        <span className="time-duration">{formatTime(duration)}</span>
                    </div>

                    <div className="audio-player-extras">
                        <div className="volume-control">
                            <button 
                                className="control-btn"
                                onClick={() => setShowVolume(!showVolume)}
                            >
                                <i className={'fa ' + (volume === 0 ? 'fa-volume-off' : volume < 0.5 ? 'fa-volume-down' : 'fa-volume-up')}></i>
                            </button>
                            {showVolume && (
                                <div className="volume-slider-wrapper">
                                    <input 
                                        type="range"
                                        min="0"
                                        max="1"
                                        step="0.01"
                                        value={volume}
                                        onChange={handleVolumeChange}
                                        className="volume-slider"
                                    />
                                </div>
                            )}
                        </div>

                        <button 
                            className="control-btn"
                            onClick={() => setShowPlaylist(!showPlaylist)}
                        >
                            <i className="fa fa-list"></i>
                        </button>
                    </div>
                </div>

                {showPlaylist && (
                    <div className="audio-playlist">
                        <div className="playlist-header">
                            <h6>Playlist</h6>
                            <button onClick={() => setShowPlaylist(false)}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                        <div className="playlist-items">
                            {playlist.map((track, index) => (
                                <div 
                                    key={track.id}
                                    className={'playlist-item ' + (currentTrackIndex === index ? 'active' : '')}
                                    onClick={() => playTrack(index)}
                                >
                                    <div className="playlist-item-thumb">
                                        <img src={track.thumbnail} alt={track.title} />
                                        {currentTrackIndex === index && isPlaying && (
                                            <i className="fa fa-volume-up playing-icon"></i>
                                        )}
                                    </div>
                                    <div className="playlist-item-info">
                                        <div className="playlist-item-title">{track.title}</div>
                                        <div className="playlist-item-artist">{track.artist}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AudioPlayer;
